<template>
    <div>
        <div class="header-spacer" style="height: 120px !important;"></div>
        <div class="container">
            <div class="row">
                <leftSideInfo />
                <allDeals />
            </div>
        </div>
    </div>
</template>

<script>
    import LeftSideInfo from "@/components/Deals/LeftSideInfo";
    import allDeals from "../../components/Deals/allDeals";
    export default {
        name: "Deals",
        components: {
            LeftSideInfo,
            allDeals,
        },
    }
</script>

<style>

</style>